import React, { useState } from 'react';
import { ReactComponent as ScreenOfDeathIcon } from 'assets/images/screen-of-death/screen-of-death.svg';
import defaultLocales from 'globals/locales/default';
import FsAlertBoard from 'ui-elements/alerts/FsAlertBoard';
import UpgradeModal from 'ui-elements/layouts/FsUserPanelLayout/SidePanel/SidePanelModals/UpgradeModal';
import { WrapperBox } from './FsScreenOfDeathBox.style-elements';
import { useButton } from './FsScreenOfDeathBox.utils';

const FsScreenOfDeathBox: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const button = useButton({ callback: setShowModal });
  return (
    <>
      <WrapperBox>
        <FsAlertBoard
          title={defaultLocales.screenOfDeath.title}
          icon={<ScreenOfDeathIcon />}
          button={button}
        >
          {defaultLocales.screenOfDeath.description}
        </FsAlertBoard>
      </WrapperBox>
      <UpgradeModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default FsScreenOfDeathBox;
